import { render, staticRenderFns } from "./credit-form.vue?vue&type=template&id=5b2beaae&scoped=true"
import script from "./credit-form.vue?vue&type=script&lang=js"
export * from "./credit-form.vue?vue&type=script&lang=js"
import style0 from "./credit-form.vue?vue&type=style&index=0&id=5b2beaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2beaae",
  null
  
)

export default component.exports